<template>
	<!-- 修改密碼 -->
	<el-dialog :close-on-click-modal="false"  :title="$t('model.get')" :visible.sync="getModel" top="5vh" @close="hide" :width="assignBillOptions.show ? (isphone?'95%':'760px') : (isphone?'90%':'50%')">
		<!-- 表單内容 -->
		 <!-- <div class="radio">
		    排序：
		    <el-radio-group v-model="reverse">
		      <el-radio :label="true">倒序</el-radio>
		      <el-radio :label="false">正序</el-radio>
		    </el-radio-group>
		  </div> -->
		<div v-loading="loading">
			<el-form :rules="rules" v-if="getModelType==1" :model="form" ref="get_form"  label-width="100px">
				<el-form-item :label="$t('model.yunAccount')" prop="">
					{{info.name}} ( {{info.username}} ) - {{$t('accountList.money')}}: 
					<span class="text_chengse">
						{{info.money==0?$t('accountList.all'):info.money}}
					</span>
				</el-form-item>
			
				<el-form-item :label="$t('accountList.getUser')" prop="user_id">
					<el-select style="width: 70%;"  v-model="form.user_id" size="small" filterable :placeholder="$t('system.select')">
					</el-option>
						<el-option v-for="item in data" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item v-if="assignBillOptions.show" label="旧账单处理">
					<div class="assign-bill-box">
						<div class="assign-bill-user">
							旧用户：{{assignBillOptions.old_user_name}}
						</div>
						<div class="assign-bill-grid">
							<div class="assign-bill-group">
								<div class="assign-bill-title">转移到新用户</div>
								<el-select class="assign-bill-select" v-model="form.transfer_months" multiple collapse-tags size="small" placeholder="选择月份">
									<el-option v-for="item in assignBillMonths" :key="'transfer-'+item.mon" :label="formatMonthLabel(item)" :value="item.mon" :disabled="monthDisabled('transfer', item)">
									</el-option>
								</el-select>
							</div>
							<div class="assign-bill-group">
								<div class="assign-bill-title">清空旧用户账单</div>
								<el-select class="assign-bill-select" v-model="form.clear_months" multiple collapse-tags size="small" placeholder="选择月份">
									<el-option v-for="item in assignBillMonths" :key="'clear-'+item.mon" :label="formatMonthLabel(item)" :value="item.mon" :disabled="monthDisabled('clear', item)">
									</el-option>
								</el-select>
							</div>
							<div v-if="assignBillOptions.can_repull==1" class="assign-bill-group">
								<div class="assign-bill-title">重拉到新用户</div>
								<el-select class="assign-bill-select" v-model="form.repull_months" multiple collapse-tags size="small" placeholder="选择月份">
									<el-option v-for="item in assignBillMonths" :key="'repull-'+item.mon" :label="formatMonthLabel(item)" :value="item.mon" :disabled="monthDisabled('repull', item)">
									</el-option>
								</el-select>
								<el-radio-group class="assign-bill-mode" v-model="form.repull_mode" size="mini">
									<el-radio-button label="remote">外部重建</el-radio-button>
									<el-radio-button label="local">本地重建</el-radio-button>
								</el-radio-group>
							</div>
						</div>
						<div v-if="hasLockedMonth" class="assign-bill-tip">已确认或已支付的月份不可处理</div>
					</div>
				</el-form-item>
				
			</el-form>
			
			<el-form :rules="rules" v-if="getModelType==2" :model="form" ref="get_form"  label-width="100px">
				<el-form-item :label="$t('accountList.getUser')" prop="">
					{{info.name}} ( {{info.username}} ) 
					<span class="text_chengse">
						{{info.money==0?$t('accountList.all'):info.money}}
					</span>
				</el-form-item>
				
				
				<el-form-item :label="$t('model.getType')">
					<el-radio-group v-model="form.rand" size="small">
						<el-radio :label="0" border>{{$t('model.getType1')}}</el-radio>
						<el-radio :label="1" border>{{$t('model.getType2')}}</el-radio>
						
					</el-radio-group>
				</el-form-item>
				
				<el-form-item  v-if="form.rand==1":label="$t('model.yunAccount')" prop="account_id">
					<el-select @change="selAccount" style="width: 70%;"  v-model="form.account_id" size="small" filterable :placeholder="$t('system.select')">
					</el-option>
						<el-option v-for="item in data" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item :label="$t('userList.odds')" prop="odds">
					<el-input v-model="form.odds" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			
				
				
			</el-form>
		</div>
		
		
		  
		
		

		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">{{$t('model.close')}}</el-button>
			<el-button :loading="loading" :disabled="loading" type="primary" @click="submit">{{$t('model.success')}}</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			getModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			},
			getModelType: {
				type: Number,
				default: 1//1账号选定，选择用户，2用户选定，选择账号
			},
			getModelTypeId: {
				type: Number,
				default: 0//getModelType==1 账号ID，getModelType==2 用户ID
			}
		},
		data() {
			return {
				loading:true,
				reverse: false,
				info: {name:'',money:0,username:'',odds:0},
				data:[],
				form:{
					user_id:'',
					account_id:'',
					type:1,
					odds:0,
					rand:0,
					type_id:0,
					transfer_months:[],
					clear_months:[],
					repull_months:[],
					repull_mode:'remote'
				},
				assignBillOptions:{
					show:0,
					old_uid:0,
					old_user_name:'',
					can_repull:0,
					months:[]
				},
				rules: {
					user_id: [{
						required: true,
						message: this.$t('model.selUser'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.odds'),
						trigger: 'blur',
					}]
				},
			}
		},
		watch: {
			getModel(newVal) {
				if(newVal){
						this.form = {
						user_id:'',
						apply_id:0,
						account_id:'',
						rand:0,//1随机
						odds:0,
						type:1,
						type_id:0,
						transfer_months:[],
						clear_months:[],
						repull_months:[],
						repull_mode:'remote'
					} 
					this.assignBillOptions = {
						show:0,
						old_uid:0,
						old_user_name:'',
						can_repull:0,
						months:[]
					}
					this.checkGetData()
				}
			},
		},
		computed:{
			assignBillMonths(){
				return this.assignBillOptions.months || []
			},
			hasLockedMonth(){
				return this.assignBillMonths.some(item=>item.is_locked==1)
			}
		},
		methods: {
			hide(){
				this.$emit('hide')
			},		
			changeNum(){
				this.$emit('changeNum')
			},
			submit(){
				this.$refs.get_form.validate(res => {
					
					if (res) {
						this.loading = true
						this.axios.post('/admin/data/getAccountUser', this.form, {
							token: true
						}).then(res => {
							this.loading = false
							let all = res.data
							
							if (all.code == 1) {
								this.changeNum()
								this.hide()
							}
							
						}).catch(err => {
							this.loading = false
						})
					}
				})
				
				
			},
			
			selAccount(e){
				let index = this.data.findIndex(item=>item.id == e)
				if(index!=-1){
					this.form.odds = this.data[index].odds 
				}
			},
			formatMonthLabel(item){
				let label = item.label || item.mon
				if(item.is_locked==1){
					label += ' / 已锁定'
				}
				return label
			},
			monthDisabled(type, item){
				if(item.is_locked==1){
					return true
				}
				let mon = item.mon
				if(type!='transfer' && this.form.transfer_months.indexOf(mon)!=-1){
					return true
				}
				if(type!='clear' && this.form.clear_months.indexOf(mon)!=-1){
					return true
				}
				if(type!='repull' && this.form.repull_months.indexOf(mon)!=-1){
					return true
				}
				return false
			},
			
			checkGetData(){
				
				this.form.type = this.getModelType
				this.form.type_id = this.getModelTypeId
				if(this.getModelType==1){
					this.form.account_id = this.getModelTypeId
				}else{
					this.form.apply_id = this.getModelTypeId
				}
				this.axios.post('/admin/data/checkGetData', this.form, {
					token: true
				}).then(res => {
					let all = res.data
					
					if (all.code == 1) {
						this.loading = false
						console.log(all)
						this.info = all.data.list.info
						this.assignBillOptions = this.info.assignment_bill_options || {
							show:0,
							old_uid:0,
							old_user_name:'',
							can_repull:0,
							months:[]
						}
						this.form.odds = this.info.odds
						
						if(this.getModelType==2){
							this.form.user_id = this.info.id
						}
						this.data = all.data.list.data
						//this.hide()
					}
					
				}).catch(err => {
					
				})
			}
		}
	}
</script>

<style>
	.phone_w{
		width: 90%;;
	}
	.pc_w{
		width: 34%;;
	}
	.assign-bill-box{
		border: 1px solid #ebeef5;
		border-radius: 4px;
		padding: 12px;
		background: #fafafa;
	}
	.assign-bill-user{
		line-height: 20px;
		margin-bottom: 10px;
		color: #606266;
	}
	.assign-bill-grid{
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 12px;
	}
	.assign-bill-group{
		min-width: 0;
	}
	.assign-bill-title{
		font-size: 13px;
		line-height: 20px;
		color: #303133;
		margin-bottom: 6px;
	}
	.assign-bill-select{
		width: 100%;
	}
	.assign-bill-mode{
		margin-top: 8px;
	}
	.assign-bill-tip{
		margin-top: 8px;
		font-size: 12px;
		color: #e6a23c;
	}
	@media (max-width: 768px){
		.assign-bill-grid{
			grid-template-columns: 1fr;
		}
	}
</style>
